"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIWindowsterminal = exports.SIWindows = exports.SIWiiu = exports.SIWhatsapp = exports.SITypescript = exports.SITwitter = exports.SIThunderbird = exports.SITelegram = exports.SITeamspeak = exports.SISublimetext = exports.SISteam = exports.SISpotify = exports.SISpeedtest = exports.SISoundcloud = exports.SISignal = exports.SISentry = exports.SIPlex = exports.SIPlaystation5 = exports.SIPlaystation4 = exports.SIPlaystation3 = exports.SIPlaystation2 = exports.SIPlaystation = exports.SIPimcore = exports.SIPihole = exports.SINintendoswitch = exports.SINextcloud = exports.SIMicrosoftteams = exports.SIMicrosoftoutlook = exports.SIMattermost = exports.SIMacos = exports.SILogmein = exports.SILinux = exports.SIJirasoftware = exports.SIIntellijidea = exports.SIGogdotcom = exports.SIGitlab = exports.SIGithub = exports.SIGitea = exports.SIGit = exports.SIFirefoxbrowser = exports.SIFilezilla = exports.SIFigma = exports.SIEpicgames = exports.SIElement = exports.SIDiscord = exports.SIDerspiegel = exports.SIChromecast = exports.SIBitwarden = exports.SI1password = exports.SIWrapper = void 0;
exports.SIYoutube = exports.SIXbox = exports.SIWireshark = exports.SIWireguard = void 0;
const SI1password_1 = __importDefault(require("./SI1password"));
exports.SI1password = SI1password_1.default;
const SIBitwarden_1 = __importDefault(require("./SIBitwarden"));
exports.SIBitwarden = SIBitwarden_1.default;
const SIChromecast_1 = __importDefault(require("./SIChromecast"));
exports.SIChromecast = SIChromecast_1.default;
const SIDerspiegel_1 = __importDefault(require("./SIDerspiegel"));
exports.SIDerspiegel = SIDerspiegel_1.default;
const SIDiscord_1 = __importDefault(require("./SIDiscord"));
exports.SIDiscord = SIDiscord_1.default;
const SIElement_1 = __importDefault(require("./SIElement"));
exports.SIElement = SIElement_1.default;
const SIEpicgames_1 = __importDefault(require("./SIEpicgames"));
exports.SIEpicgames = SIEpicgames_1.default;
const SIFigma_1 = __importDefault(require("./SIFigma"));
exports.SIFigma = SIFigma_1.default;
const SIFilezilla_1 = __importDefault(require("./SIFilezilla"));
exports.SIFilezilla = SIFilezilla_1.default;
const SIFirefoxbrowser_1 = __importDefault(require("./SIFirefoxbrowser"));
exports.SIFirefoxbrowser = SIFirefoxbrowser_1.default;
const SIGit_1 = __importDefault(require("./SIGit"));
exports.SIGit = SIGit_1.default;
const SIGitea_1 = __importDefault(require("./SIGitea"));
exports.SIGitea = SIGitea_1.default;
const SIGithub_1 = __importDefault(require("./SIGithub"));
exports.SIGithub = SIGithub_1.default;
const SIGitlab_1 = __importDefault(require("./SIGitlab"));
exports.SIGitlab = SIGitlab_1.default;
const SIGogdotcom_1 = __importDefault(require("./SIGogdotcom"));
exports.SIGogdotcom = SIGogdotcom_1.default;
const SIIntellijidea_1 = __importDefault(require("./SIIntellijidea"));
exports.SIIntellijidea = SIIntellijidea_1.default;
const SIJirasoftware_1 = __importDefault(require("./SIJirasoftware"));
exports.SIJirasoftware = SIJirasoftware_1.default;
const SILinux_1 = __importDefault(require("./SILinux"));
exports.SILinux = SILinux_1.default;
const SILogmein_1 = __importDefault(require("./SILogmein"));
exports.SILogmein = SILogmein_1.default;
const SIMacos_1 = __importDefault(require("./SIMacos"));
exports.SIMacos = SIMacos_1.default;
const SIMattermost_1 = __importDefault(require("./SIMattermost"));
exports.SIMattermost = SIMattermost_1.default;
const SIMicrosoftoutlook_1 = __importDefault(require("./SIMicrosoftoutlook"));
exports.SIMicrosoftoutlook = SIMicrosoftoutlook_1.default;
const SIMicrosoftteams_1 = __importDefault(require("./SIMicrosoftteams"));
exports.SIMicrosoftteams = SIMicrosoftteams_1.default;
const SINextcloud_1 = __importDefault(require("./SINextcloud"));
exports.SINextcloud = SINextcloud_1.default;
const SINintendoswitch_1 = __importDefault(require("./SINintendoswitch"));
exports.SINintendoswitch = SINintendoswitch_1.default;
const SIPihole_1 = __importDefault(require("./SIPihole"));
exports.SIPihole = SIPihole_1.default;
const SIPimcore_1 = __importDefault(require("./SIPimcore"));
exports.SIPimcore = SIPimcore_1.default;
const SIPlaystation_1 = __importDefault(require("./SIPlaystation"));
exports.SIPlaystation = SIPlaystation_1.default;
const SIPlaystation2_1 = __importDefault(require("./SIPlaystation2"));
exports.SIPlaystation2 = SIPlaystation2_1.default;
const SIPlaystation3_1 = __importDefault(require("./SIPlaystation3"));
exports.SIPlaystation3 = SIPlaystation3_1.default;
const SIPlaystation4_1 = __importDefault(require("./SIPlaystation4"));
exports.SIPlaystation4 = SIPlaystation4_1.default;
const SIPlaystation5_1 = __importDefault(require("./SIPlaystation5"));
exports.SIPlaystation5 = SIPlaystation5_1.default;
const SIPlex_1 = __importDefault(require("./SIPlex"));
exports.SIPlex = SIPlex_1.default;
const SISentry_1 = __importDefault(require("./SISentry"));
exports.SISentry = SISentry_1.default;
const SISignal_1 = __importDefault(require("./SISignal"));
exports.SISignal = SISignal_1.default;
const SISoundcloud_1 = __importDefault(require("./SISoundcloud"));
exports.SISoundcloud = SISoundcloud_1.default;
const SISpeedtest_1 = __importDefault(require("./SISpeedtest"));
exports.SISpeedtest = SISpeedtest_1.default;
const SISpotify_1 = __importDefault(require("./SISpotify"));
exports.SISpotify = SISpotify_1.default;
const SISteam_1 = __importDefault(require("./SISteam"));
exports.SISteam = SISteam_1.default;
const SISublimetext_1 = __importDefault(require("./SISublimetext"));
exports.SISublimetext = SISublimetext_1.default;
const SITeamspeak_1 = __importDefault(require("./SITeamspeak"));
exports.SITeamspeak = SITeamspeak_1.default;
const SITelegram_1 = __importDefault(require("./SITelegram"));
exports.SITelegram = SITelegram_1.default;
const SIThunderbird_1 = __importDefault(require("./SIThunderbird"));
exports.SIThunderbird = SIThunderbird_1.default;
const SITwitter_1 = __importDefault(require("./SITwitter"));
exports.SITwitter = SITwitter_1.default;
const SITypescript_1 = __importDefault(require("./SITypescript"));
exports.SITypescript = SITypescript_1.default;
const SIWhatsapp_1 = __importDefault(require("./SIWhatsapp"));
exports.SIWhatsapp = SIWhatsapp_1.default;
const SIWiiu_1 = __importDefault(require("./SIWiiu"));
exports.SIWiiu = SIWiiu_1.default;
const SIWindows_1 = __importDefault(require("./SIWindows"));
exports.SIWindows = SIWindows_1.default;
const SIWindowsterminal_1 = __importDefault(require("./SIWindowsterminal"));
exports.SIWindowsterminal = SIWindowsterminal_1.default;
const SIWireguard_1 = __importDefault(require("./SIWireguard"));
exports.SIWireguard = SIWireguard_1.default;
const SIWireshark_1 = __importDefault(require("./SIWireshark"));
exports.SIWireshark = SIWireshark_1.default;
const SIXbox_1 = __importDefault(require("./SIXbox"));
exports.SIXbox = SIXbox_1.default;
const SIYoutube_1 = __importDefault(require("./SIYoutube"));
exports.SIYoutube = SIYoutube_1.default;
exports.SIWrapper = {
    SI1password: SI1password_1.default,
    SIBitwarden: SIBitwarden_1.default,
    SIChromecast: SIChromecast_1.default,
    SIDerspiegel: SIDerspiegel_1.default,
    SIDiscord: SIDiscord_1.default,
    SIElement: SIElement_1.default,
    SIEpicgames: SIEpicgames_1.default,
    SIFigma: SIFigma_1.default,
    SIFilezilla: SIFilezilla_1.default,
    SIFirefoxbrowser: SIFirefoxbrowser_1.default,
    SIGit: SIGit_1.default,
    SIGitea: SIGitea_1.default,
    SIGithub: SIGithub_1.default,
    SIGitlab: SIGitlab_1.default,
    SIGogdotcom: SIGogdotcom_1.default,
    SIIntellijidea: SIIntellijidea_1.default,
    SIJirasoftware: SIJirasoftware_1.default,
    SILinux: SILinux_1.default,
    SILogmein: SILogmein_1.default,
    SIMacos: SIMacos_1.default,
    SIMattermost: SIMattermost_1.default,
    SIMicrosoftoutlook: SIMicrosoftoutlook_1.default,
    SIMicrosoftteams: SIMicrosoftteams_1.default,
    SINextcloud: SINextcloud_1.default,
    SINintendoswitch: SINintendoswitch_1.default,
    SIPihole: SIPihole_1.default,
    SIPimcore: SIPimcore_1.default,
    SIPlaystation: SIPlaystation_1.default,
    SIPlaystation2: SIPlaystation2_1.default,
    SIPlaystation3: SIPlaystation3_1.default,
    SIPlaystation4: SIPlaystation4_1.default,
    SIPlaystation5: SIPlaystation5_1.default,
    SIPlex: SIPlex_1.default,
    SISentry: SISentry_1.default,
    SISignal: SISignal_1.default,
    SISoundcloud: SISoundcloud_1.default,
    SISpeedtest: SISpeedtest_1.default,
    SISpotify: SISpotify_1.default,
    SISteam: SISteam_1.default,
    SISublimetext: SISublimetext_1.default,
    SITeamspeak: SITeamspeak_1.default,
    SITelegram: SITelegram_1.default,
    SIThunderbird: SIThunderbird_1.default,
    SITwitter: SITwitter_1.default,
    SITypescript: SITypescript_1.default,
    SIWhatsapp: SIWhatsapp_1.default,
    SIWiiu: SIWiiu_1.default,
    SIWindows: SIWindows_1.default,
    SIWindowsterminal: SIWindowsterminal_1.default,
    SIWireguard: SIWireguard_1.default,
    SIWireshark: SIWireshark_1.default,
    SIXbox: SIXbox_1.default,
    SIYoutube: SIYoutube_1.default,
};
